//export const loadScript = (src: string, options?: {
//    async?: boolean;
//    defer?: boolean;
//    crossOrigin?: string;
//    attributes?: object;
//}) => {
//    if (typeof window === 'undefined') return;

//    if (document.querySelector(`script[src="${src}"]`)) return;

//    const script = document.createElement('script');
//    script.src = src;
//    script.async = options?.async ?? true;
//    script.defer = options?.defer ?? true;

//    if (options?.crossOrigin && ['anonymous', 'use-credentials'].includes(options.crossOrigin)) {
//        script.crossOrigin = options.crossOrigin;
//    }

//    if (options?.attributes) {
//        Object.entries(options.attributes).forEach(([key, value]) => {
//            script.setAttribute(key, value);
//        });
//    }

//    // L�gg till skriptet till head utan att v�nta p� att det ska laddas
//    document.head.appendChild(script);
//};

export const loadScript = (src: string, options?: {
    async?: boolean;
    defer?: boolean;
    crossOrigin?: string;
    attributes?: Record<string, string>;
}): Promise<void> => {
    return new Promise((resolve, reject) => {
        if (typeof window === 'undefined') return resolve();

        const existingScript = document.querySelector(`script[src="${src}"]`);

        if (existingScript) {
            return resolve();
        }

        const script = document.createElement('script');
        script.src = src;
        script.async = options?.async ?? true;
        script.defer = options?.defer ?? true;

        if (options?.crossOrigin && ['anonymous', 'use-credentials'].includes(options.crossOrigin)) {
            script.crossOrigin = options.crossOrigin;
        }

        if (options?.attributes) {
            Object.entries(options.attributes).forEach(([key, value]) => {
                script.setAttribute(key, value);
            });
        }

        script.onload = () => {
            console.log(`[ScriptLoader]: Loaded ${src}`);
            resolve();
        };

        script.onerror = () => {
            console.error(`[ScriptLoader]: Failed to load ${src}`);
            reject(new Error(`Failed to load script: ${src}`));
        };

        document.head.appendChild(script);
    });
};
